import { ParentState } from "@checkout/types";
import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import type { WalletPaymentParentContext } from "./types";

export const guards = {
  // Offer apply/remove goes through quote/update, which requires a quoted cart.
  hasQuoteCipherText: (ctx: WalletPaymentParentContext, _event: unknown) =>
    Boolean(ctx[ParentState.cartQuote]?.priceQuoteCipherText),
};

export const GuardTypes = getObjectKeysAsObject(guards);
